import { useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useQuery } from '@common-fe/common-fe';
import { ServiceConfig } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const QUERY_KEY = 'GET_SERVICE_CONFIGS';

export default (defaultId?: string) => {
  const {
    params: { id },
  } = useRouteMatch<{ id: string }>();

  const { data, isLoading } = useQuery([QUERY_KEY, id, defaultId], () =>
    api.get(API_URL.SERVICE_CONFIGS, {
      params: {
        health_plan_id: defaultId || id,
      },
    })
  );

  const formatedData = useMemo(() => {
    const list = data?.data || [];
    return list.map((item) => {
      const formatedItem: ServiceConfig = {
        id: toString(item.id),
        serviceId: toString(item.service?.id),
        serviceName: item.service?.name,
        processingTierId: toString(item.processing_tier_id),
        healthPlanId: toString(item.health_plan_id),
        description: item.description,
        claimValue: item.claim_value,
        isAppliedDeductible: item.is_applied_deductible,
        paymentType: item.payment_type as string,
        paymentRules: item?.payment_rules?.map((rule) => ({
          planId: toString(rule.plan?.id),
          planName: rule.plan?.name,
          maxAmount: rule.max_amount,
          percentage: rule.percentage,
        })),
      };
      return formatedItem;
    });
  }, [data]);

  return {
    isLoading,
    data: formatedData,
  };
};
